<template>
  <div class="come-back-to-admin__container">
    <el-button
      class="come-back-to-admin__container--button"
      size="mini"
      type="danger"
      @click="handleClickBtn"
    >
      Вернуться к СЕО
    </el-button>
  </div>
</template>

<script>
import { CHANGE_PROFILE } from '@/store/actions/userprofile'

export default {
  name: 'ComeBackToAdmin',
  data() {
    return {
      userData: {},
    }
  },
  created() {
    this.userData = {
      token: {
        token: localStorage.getItem('ceo-token'),
      },
      user_type: 6,
    }
  },
  methods: {
    handleClickBtn() {
      this.$store.dispatch(`userProfile/${CHANGE_PROFILE}`, this.userData)
    },
  },
}
</script>

<style lang="sass">
@import "~@/assets/styles/mixins"

.come-back-to-admin
  &__container
    text-align: center
    position: fixed
    top: 5rem
    right: 2rem
    z-index: 100000
</style>
